<template>
	<div class="answer-val answer-fill-sentence position-rel"
		:class="`answer-${parent.type}`"
	>
		<label class="display-flex">
			<b v-if="dataSource.code && dataSource.code !== '' && parent.answers.length > 1">{{ dataSource.code }} </b>
			<div class="sentence-content">
				<v-runtime-template :template="contentStringFillType"></v-runtime-template>
			</div>
		</label>
	</div>
</template>

<script>
	import mixinsQuestionPreview from './../../_store/mixinsQuestionPreview'
	import * as types from './../../_store/constants'
	import { setContentQuestionFillSelect, getContentQuestionFillSelect, resetContentQuestionFillSelect } from './../../_store/helpers'
	import { BLANK_FILL_TXT, BLANK_FILL_SELECT, BLANK_FILL_SELECT_SHORT } from '@/store/common/constants'
	import { mapState, mapGetters, mapActions } from 'vuex'
	import VRuntimeTemplate from "v-runtime-template"
	import { stripHtml } from '@/helpers/functions'

	export default {
		name: 'fillBlankOrSelect',
		mixins: [ mixinsQuestionPreview ],
		props: {
      dataSource: Object,
      nameField: String,
      location: Number,
      parent: Object,
      isDontShowResultSaved: Boolean
    },
		components: {
			VRuntimeTemplate,
			DropdownCustom: () => import('@/components/DropdownCustom.vue')
		},
		data () {
			return {
				types,
				contentFillType: [],
				contentStringFillType: '',
				fillSelectSplit: [],
				validate: [],
				optionSelect: [],
			}
		},
		computed: {
			...mapState(types.STORE_KEY, ['valVituralKeyboard']),
			...mapGetters({
				validate_question: `${types.STORE_KEY}/validate_question`,
				question: `${types.STORE_KEY}/question`,
			})
		},
		watch: {
			validate_question(newVal) {
				this.convertData('validate')
			},
			question(newVal, oldVal) {
				this.convertData('edit_question')
			},
			// '$route': 'resetContentFillBlank'
		},
		mounted() {
			this.convertData()
		},
		beforeDestroy() {
			// console.log('Befor destroy');
			resetContentQuestionFillSelect();
		},
		methods: {
			...mapActions(types.STORE_KEY, ['setVituralKeyVal']),

			displayHtmlCorrect(val) {
				// return val ? val.replace('<p>', '').replace('</p>', '') : '';
				return val ? stripHtml(val) : '';
			},

			// resetContentFillBlank() {
			// 	console.log('Func reset');
			// 	resetContentQuestionFillSelect();
			// },

			async convertData(action = null) {
				let self = this;
				// let placeholderInput = [2,3.4].includes(self.parent.layoutId) ? '?' : 'Điền đáp án';
				let placeholderInput = '?';
				// let questionIsDel = false;

				self.contentStringFillType = '';
				self.contentFillType = [];
        self.optionSelect = []
				
				let typeQuestion = self.parent.type;
				// Set data options select form
				await self.converDataSelect();
				if(action !== null && self.dataSource.validate) {
					self.validate = self.dataSource.validate;
				}

				let dataContent = self.replaceContent(self.dataSource.content);

				self.contentFillType = await typeQuestion === types.TYPE_SELECT ? dataContent.split('</p>') : [self.dataSource.content];
				self.contentFillType.map((fill, index) => {
					self.fillSelectSplit[index] = fill.split(typeQuestion === types.TYPE_SELECT ? BLANK_FILL_SELECT : BLANK_FILL_TXT);
				});

				let lengthSelectOptions = self.optionSelect.length;


				// console.log('Before set content: ', self.fillSelectSplit, self.optionSelect);

				for(let i = 0; i < lengthSelectOptions; i++) {
					if(!self.optionSelect[i]) {
						// self.fillSelectSplit.splice(i, 0, ["null"]);
						self.optionSelect[i] = [{position_del: true}];
						// questionIsDel = true;
						if(typeQuestion === types.TYPE_SELECT) {
							self.fillSelectSplit.splice(i, 0, ["null"]);
						} else {
							self.fillSelectSplit[0].splice(i, 0, "null");
						}
					}
				}
				
				self.setOptionSelectByContentFill()
				// console.log('Done split: ', self.fillSelectSplit, self.optionSelect);
				// console.log('Done split: ', self.fillSelectSplit);
				let lengthFillSplit = self.fillSelectSplit.length;
				// Save fillSelect tpl 
				setContentQuestionFillSelect(self.fillSelectSplit);

				self.fillSelectSplit.map((fill, index) => {
					let fillLength = fill.length;
					
					// console.log('Fill arr length: ', fillLength, fill, index)
					if(index === 0) {
						self.contentStringFillType += '<div>';
					}
					if(fill && fillLength > 0) {
						// let lengthFillTxt = fill.length;
						for(let indexFill in fill) {
							let txt = fill[indexFill];
							let pos = parseInt(indexFill);
							// console.log('For of: ', pos, index + pos, index)
							// console.log('AAAAAAAAAAAAAAA', indexFill, questionIsDel, self.optionSelect[index + pos])
					
							// console.log('set txt pos: ', txt)  
							if(txt && txt !== 'null'  ) {

								if(pos === 0 && (txt.substring(0, 2) != '<p') && !dataContent.includes('<table')) {
									self.contentStringFillType += `<p>`;
								}
								if(pos < fillLength - 1) {
									let formData = ``;
									// console.log('Select: ', index, pos)
									// let indexForSetData = questionIsDel ? index + pos : pos;
									if(typeQuestion === types.TYPE_SELECT) {
										let indexAnswerChoosed = self.optionSelect[index + pos] ? self.optionSelect[index + pos].findIndex(op => op.nameChoose && op.valChoose) : -1;
										// let nameChoosed = indexAnswerChoosed > -1 ? self.optionSelect[pos][indexAnswerChoosed]['nameChoose'] : '?';
										// let valChoosed = indexAnswerChoosed > -1 ? self.optionSelect[pos][indexAnswerChoosed]['valChoose'] : null;
										// console.log('Name choose: ', nameChoosed)
										formData = `
											<DropdownCustom 
												:nameOptionDefault="${indexAnswerChoosed} > -1 ? optionSelect[${index + pos}][${indexAnswerChoosed}]['nameChoose'] : '?'"
												:valoptionActive="${indexAnswerChoosed} > -1 ? optionSelect[${index + pos}][${indexAnswerChoosed}]['valChoose'] : null"
												:options="optionSelect[${index + pos}]"
												:optionValueKey="'answerId'"
												:optionNameKey="'content'"
												:location="location"
												:type="parent.type"
												:position="${index + pos}"
												:class="{
													'error': !isDontShowResultSaved && dataSource.validate && dataSource.validate.length > 0 && (!dataSource.validate[${index + pos}] || dataSource.validate[${index + pos}] === 'false'),
													'success': !isDontShowResultSaved && dataSource.validate && dataSource.validate.length > 0 && dataSource.validate[${index + pos}] && dataSource.validate[${index + pos}] !== 'false'
												}"
												@changeSelect="changeValSelect"
											/>
										`;
									} else {
										formData = `<input 
														class="display-inline text-center input-hide-place" 
														:id="'fill_blank_' + location + ${index + pos} + dataSource.answerId"
														:value="dataSource.validateVal && dataSource.validateVal.length > 0 && dataSource.validateVal[${index + pos}] ? displayHtmlCorrect(dataSource.validateVal[${index + pos}]) : ''"
														@keyup="handleFocus($event, {answerId: dataSource.answerId, location, type: parent.type, questionId: dataSource.questionId, fill_index: ${index + pos}})"
														@focus="handleFocus($event, {answerId: dataSource.answerId, location, type: parent.type, questionId: dataSource.questionId, fill_index: ${index + pos}})"
														@change="changeAnswer($event, {answerId: dataSource.answerId, location, type: parent.type, questionId: dataSource.questionId, fill_index: ${index + pos}})"
														@blur="changeAnswer($event, {answerId: dataSource.answerId, location, type: parent.type, questionId: dataSource.questionId, fill_index: ${index + pos}})"
														placeholder="${placeholderInput}" 
														:class="{
															'error': !isDontShowResultSaved && dataSource.validate && dataSource.validate.length > 0 && (!dataSource.validate[${index + pos}] || dataSource.validate[${index + pos}] === 'false'), 
															'success': !isDontShowResultSaved && dataSource.validate && dataSource.validate.length > 0 && dataSource.validate[${index + pos}] && dataSource.validate[${index + pos}] !== 'false'
														}"
                            autocomplete="off"
													/>`;
									}

									self.contentStringFillType += `${txt}${formData}`; 
								}
								if(pos === (fillLength - 1)) {
									self.contentStringFillType += `${txt}</p>`;
								}
							}
						}
					}
					// console.log('Index fill: ', index)
					if(index === (lengthFillSplit - 1)) {
						// console.log('End tag', index, lengthFillSplit)
						self.contentStringFillType += '</div>';
					}
				})
			},

			replaceContent(content) {
				let textNeedReplace = new RegExp(this.parent.type === types.TYPE_SELECT ? BLANK_FILL_SELECT_SHORT : BLANK_FILL_TXT, "gi");
				return content.replace(textNeedReplace, `${this.parent.type === types.TYPE_SELECT ? BLANK_FILL_SELECT_SHORT : BLANK_FILL_TXT}&nbsp;`);
			},

			setOptionSelectByContentFill() {
				// console.log('Questiion: ', this.question)
				let self = this;
				let lengthFill = self.fillSelectSplit.length;
				self.fillSelectSplit.map((fill, index) => {
					// if((!fill || ( fill.length === 1 && !fill[0])) && index < lengthFill - 1 && self.question.type !== types.TYPE_SELECT) {
					// 	self.optionSelect.splice(index, 0, [{isDataNull: true}]);
					// } else 
					if((!fill || fill.length === 1) && index < lengthFill - 1) {
						self.optionSelect.splice(index, 0, [{isDataNull: true}]);
					}
				})
			},

			converDataSelect() {
				let self = this;
				self.parent.answers.map(ans => {
					if(ans.position) {
						let positionItem = ans.position.split('_');
						if(parseInt(positionItem[0]) === parseInt(self.location)) {
							if(self.optionSelect[positionItem[1]]) {
								self.optionSelect[positionItem[1]].push(ans);
							} else {
								self.optionSelect[positionItem[1]] = [ans]
							}
						}
					}
				})
			},

			countChildAnswer(indexP, positionChar, arrChar) {
				let result = 0;
				arrChar.map((da, index) => {
					if(index < indexP) {
						result += ((arrChar[index].length - 1) + positionChar);
					}
				});
				return result;
			},

			changeValSelect(val) {
				// console.log('Change answer 4: ', val);
				this.parent.answers.map(ans => {
					if(ans.position && ans.position === `${val.location}_${val.index}`) {
						// console.log('Change answer 1: ', ans, val);
						if( ans.answerId === val.evt.target.value ) {
							// console.log('Change answer: ', ans);
							ans['nameChoose'] = val.nameChoose;
							ans['valChoose'] = val.valChoose;
						} else {
							ans.nameChoose && delete ans.nameChoose;
							ans.valChoose && delete ans.valChoose;
						}
					}
				})
				this.changeAnswer({...val.evt}, {location: val.location, type: val.type, select_index: val.index, position_display: val.position_display});
			},

			handleFocus(val, info = {}) {
				let halfWindowHeight = window.innerHeight/2;
				let offsetTopElm = document.getElementById(`fill_blank_${info.location}${info.fill_index}${info.answerId}`).getBoundingClientRect().top;
        let offsetLeftElm = document.getElementById(`fill_blank_${info.location}${info.fill_index}${info.answerId}`).getBoundingClientRect().left;
        // input position > 80% screen 
        let spaceHeightInput = (offsetTopElm/window.innerHeight)*100 > 80 ? 20 : 50  // 50 or 20 is height input
				// Obj have ref key support render value onpress vitural keyboard
				this.setVituralKeyVal({
					...info,
					val: val.target.value,
					ref: `fill_blank_${info.location}${info.fill_index}${info.answerId}`,
					isOverHaflScreen: offsetTopElm > halfWindowHeight ? true : false,
          top: offsetTopElm + spaceHeightInput,
          left: offsetLeftElm/2 // /2 is box center
				})
			},
		}
	}
</script>

<style lang="scss" scoped>
</style>